export enum MODAL_TYPE {
  DEFAULT,
  CONFIRM_EDIT,
  DELETE,
  ERROR,
  SUCCESS,
  CONFIRM_MAPPING,
  BLANK,
  LIST_VIEW,
  EDIT_VAT_INDEX,
  POS_LEAVE_STEP_CONFIRM,
  POS_NO_FOOD_FOUND,
  POS_DETAIL,
  BACK_TO_PREVIOUS,
  PICK_REPORT,
  PRODUCT_LIMIT,
}

export enum GENERAL_REQUEST_ID_LIST {
  GET_TNC = 'GET_TNC',
  GET_TNC_HTML = 'GET_TNC_HTML',
  POST_TNC = 'POST_TNC',
  POST_WEB_LOG = 'POST_WEB_LOG',
  GET_GENERAL_CONFIG = 'GET_GENERAL_CONFIG',
}

export const DATE_FORMAT_YEAR_START_NO_TZ = 'YYYY-MM-DD';
export const DATE_PICKER_FORM = 'DD MMM YYYY';
export const DEFAULT_PAGE_SIZE = 30;
